import { render, staticRenderFns } from "./AppearanceNewColorForm.vue?vue&type=template&id=4d595c44&scoped=true&"
import script from "./AppearanceNewColorForm.vue?vue&type=script&lang=js&"
export * from "./AppearanceNewColorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d595c44",
  null
  
)

export default component.exports